import React, {Component} from 'react';
import firebase from 'firebase';
import moment from 'moment';
import { connect } from 'react-redux'
import 'moment/locale/es';
import './style.css';
import AsignacionConductores from './AsignacionConductores';
import CancelacionViaje from './CancelacionViaje';
import copyright from '../../img/copyright-gray.png';

import { setProgramacion } from './../../actions'

class Rutas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAsignacion:true,
            empresas:[],
            empresa:{},
            conductores: [],
            vehiculos: [],
            filteredRutas:[],
            tiposViajes:[],
            isLoading:true,
            fecha:''
        }
    }

    async componentDidMount(){
        await this.getEmpresas();
        await this.init();
        this.getTiposViaje();
        this.getConductores();
        this.getVehiculos();
    }

    //vehiculos no liberados correctamente
    liberarVehiculos = async (key, programacionDia) =>{
        const snap = await firebase.database().ref().child('Vehiculos').child(key).child('viajeAsignado').once('value');
        const viajeAsignado = snap.val();

        if(viajeAsignado && viajeAsignado == programacionDia)
            firebase.database().ref().child('Vehiculos').child(key).update({viajeAsignado:false, estado: "Disponible"})
    }

    getFechaEspecifica=(fecha)=>{
        const { programacionDia, setProgramacion } = this.props;
        for (const key in programacionDia)
            firebase.database().ref('ProgramacionDia/' + key + '/estado').off();
            

        setProgramacion({});
        this.setState({isLoading:true, fecha:moment(fecha).format('DD/MM/YYYY')});
        this.init(fecha);
    }

    componentWillUnmount = () => {
        const { programacionDia } = this.props;
        const { conductores, vehiculos } = this.state;

        for (const item of conductores)
            firebase.database().ref('/Empleados/'+item.value+'/viajeAsignado').off('value');

        for (const item of vehiculos)
            firebase.database().ref('/Vehiculos/'+item.value+'/viajeAsignado').off('value');

        for (const key in programacionDia)
            firebase.database().ref('ProgramacionDia/' + key + '/estado').off();

    }

    getTiposViaje() {
        firebase.database().ref('TiposViajes').once('value').then(snap => {
            let tiposViajes = [];
            let o = { label: 'Todas las rutas', value: 'Todos' };
            tiposViajes.push(o);
            snap.forEach(element => {
                let obje = element.val();
                o = { label: obje.nombre, value: element.key };
                tiposViajes.push(o);
            });
            this.setState({ tiposViajes });
        })
    }

    async getEmpresas() {
        let empresas = [];
        empresas.push({ value: 0, label: 'Todas las Empresas' })
        firebase.database().ref("Empresa").once("value", snap => {

            snap.forEach(element => {
                empresas.push({
                    value: element.key,
                    label: element.val().codigo_empresa
                });
            });
            this.setState({ empresas, empresa: empresas[0] });
        });
    }

    async init(date=new Date()){
        let mes        = date.getMonth() + 1;
        mes            = parseInt(mes) < 10 ? '0' + mes : mes;
        let fechaB     = new Date(date.getFullYear() + '/' + mes + '/' + date.getDate());
        let dateFormat = fechaB.toDateString() + ' 00:00:00 GMT-0600 (hora estándar central)';
        const snap     = await firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(dateFormat)).once('value')
        this.getProgramacionDia(snap);
    }

    async getProgramacionDia(snap) {

        const data = snap.val();
        for (const key in data) {
            data[key].key=key;
            data[key].nombProgra = data[key].programacionF.vuelo;
            await this.setProgramacionDia(key, data[key]);

            if((data[key].estado == 'Cancelado' || data[key].estado == 'Finalizado') && data[key].vehiculo)
                this.liberarVehiculos(data[key].vehiculo, key);
        }
        this.filterRutas();
        this.setState({ isLoading: false, isStarting: false });

        snap.forEach(element => {

            firebase.database().ref('ProgramacionDia/' + element.key + '/estado').off();
            firebase.database().ref('ProgramacionDia/' + element.key + '/estado').on('value', async snap => {
                const estado = snap.val();
                if(this.props.programacionDia[element.key].estado != estado){
                    const snapCambio = await firebase.database().ref('ProgramacionDia/' + element.key).once('value');
                    const data = snapCambio.val();
                    data.nombProgra = data.programacionF.vuelo;
                    await this.setProgramacionDia(element.key, data);
                    await this.filterRutas();
                    if((data.estado == 'Cancelado' || data.estado == 'Finalizado') && data.vehiculo)
                        this.liberarVehiculos(data.vehiculo, element.key)
                }
            })
            
        });
    }

    async setProgramacionDia(key, datos){
        const {empresa}         = this.state;
        const {programacionDia} = this.props


        let obje = {};

        if (empresa.value === 0) {
            let splitH          = datos["horaInicio"] !== undefined ? datos.horaInicio.split(":") : ["00", "00"];
            let now             = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
            obje                = { ...datos, key, horaInicio: now, solicitante: datos.programacionF.solicitante };

            obje['estadoViaje'] = datos.estado;
        } else {
            if (datos.programacionF.solicitante === empresa.value) {
                let splitH          = datos.horaInicio.split(":");
                let now             = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                obje                = { ...datos, key, horaInicio: now, solicitante: datos.programacionF.solicitante };

                obje['estadoViaje'] = datos.estado;
            }
        }

        programacionDia[key]=obje;

        const { setProgramacion } = this.props;
        setProgramacion(programacionDia);
    }

    filterRutas() {
        const { programacionDia } = this.props;
        let r = Object.values(programacionDia);
        r.sort((a, b) => {
            let horaA       = a.horaInicio;
            let horaB       = b.horaInicio;
            let splitA      = horaA.split(':');
            let splitB      = horaB.split(':');
            let horaInicioA = moment().hour(Number(splitA[0])).minute(Number(splitA[1])).format('HHmm');
            let horaInicioB = moment().hour(Number(splitB[0])).minute(Number(splitB[1])).format('HHmm');
            return parseInt(horaInicioA) - parseInt(horaInicioB);
        });

        const result = r;   // = viajes;
        // this.state.filtro.value === 'Todos' ?
        // viajes : 
        // viajes.filter(ruta => '' + ruta.rutaF.tipoViaje === this.state.filtro.value);
        
        this.setState({filteredRutas:result})
    }

    async getConductores() {
        const snap = await firebase.database().ref().child('Empleados').once('value');
        const data = snap.val();

        const conductores = [];

        for (const key in data) {
            const obj = { label: data[key].nombre, value: key, espera: data[key].espera, viajeAsignado: data[key].viajeAsignado };
            conductores.push(obj);
        }

        await this.setState({ conductores })

        for (const item of conductores) {
            
            firebase.database().ref('/Empleados/'+item.value+'/viajeAsignado').off('value')
            firebase.database().ref('/Empleados/'+item.value+'/viajeAsignado').on('value', async snap=>{
                
                const viajeAsignado = snap.val();
                if(viajeAsignado){
                    this.asignarConductor(viajeAsignado, item.value)
                    // this.filterRutas();
                
                }else{
                    if(item.viajeAsignado){
                        this.asignarConductor(item.viajeAsignado, '')
                        // this.filterRutas();
                    }
                }


                this.setState((state, props)=>{
                    const index                           = state.conductores.findIndex(conductor=> item.value==conductor.value );
                    const arrayConductores                = state.conductores;
                    arrayConductores[index].viajeAsignado = viajeAsignado; 
                    return {
                        conductores:arrayConductores
                    }
                })
            });
        }
            // this.filterRutas();
    }

    asignarConductor(key, conductor){
        const {programacionDia, setProgramacion} = this.props
        if(programacionDia[key]){   //verifica si el viaje asignado es del dia seleccionado
            programacionDia[key].conductor=conductor;
            setProgramacion(programacionDia);
        }
    }

    async getVehiculos() {
        const snap = await firebase.database().ref().child('Vehiculos').once('value');
        const data = snap.val();

        let vehiculos = [];

        for (const key in data) {
            if (data[key].movil !== undefined) {
                const obj = { label: 'M-' + data[key].movil + ' (' + data[key].placa + ')', value: key, estado: data[key].estado, empresas: data[key].empresas, viajeA: data[key].viajeAsignado };
                vehiculos.push(obj);
            }
        }

        const vehiculosActivos = vehiculos.filter(vehiculo => vehiculo.estado != 'Inactivo');
        await this.setState({ vehiculos: vehiculosActivos })

        for (const item of vehiculosActivos) {
            firebase.database().ref('/Vehiculos/'+item.value+'/viajeAsignado').off('value');
            firebase.database().ref('/Vehiculos/'+item.value+'/viajeAsignado').on('value', async snap=>{

                const viajeAsignado = snap.val();
                if(viajeAsignado){
                    this.asignarVehiculo(viajeAsignado, item.value)
                    // this.filterRutas();

                }else{
                    if(item.viajeA){
                        this.asignarVehiculo(item.viajeA, '')
                        // this.filterRutas();
                    }
                }
                
                this.setState((state, props)=>{
                    const index                  = state.vehiculos.findIndex(vehiculo=> item.value==vehiculo.value );
                    const arrayVehiculos         = state.vehiculos;
                    arrayVehiculos[index].viajeA = viajeAsignado; 

                    if(viajeAsignado)
                        arrayVehiculos[index].estado = "Asignado"; 
                    else
                        arrayVehiculos[index].estado = "Disponible"; 

                    // let vehiculosActivos = vehiculos.filter(vehiculo => vehiculo.estado != 'Inactivo');
                    return {
                        vehiculos:arrayVehiculos
                    }
                })
            });
        }
    }

    asignarVehiculo(key, vehiculo){
        const {programacionDia, setProgramacion} = this.props
        if(programacionDia[key]){   //verifica si el viaje asignado es del dia seleccionado
            programacionDia[key].vehiculo=vehiculo;
            setProgramacion(programacionDia);
        }
    }

    changeEmpresa = (event) => { 

        this.setState({ empresa: event });
        // this.getProgramacionDia(event, this.state.programacion); // cambiar?
        // this.fecha1.value = 'dd/mm/aaaa';
    }



  render(){
      const conductoresFiltered = this.state.conductores.filter(conductor => conductor.viajeAsignado===false)
      const vehiculosFiltered = this.state.vehiculos.filter(vehiculo => vehiculo.viajeA===false)
        return(
            <div>
                <div className="container">
                    <div className="row header-margin-top">
                        <div className="col-md-1">
                            <i className="fa fa-user-plus fa-3x" style={{color:"#B2B2B2", width:50, height:50}}></i>
                        </div>
                        <div className="col-md-11">
                            <h3 className="title-blue">Asignación de Conductores</h3>
                            <span className="text-info">Asignación de conductores a un viaje.</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active show" onClick={()=>this.setState({isAsignacion:true})} id="asignacion-tab" data-toggle="tab" href="#asignacion" role="tab" aria-controls="asignacion"
                                    aria-selected="true"><i className="fa fa-check"></i>&nbsp;&nbsp;&nbsp;Asignación de Conductores</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link nav-link2" onClick={()=>this.setState({isAsignacion:false})} id="estatus-tab" data-toggle="tab" href="#cancelacion" role="tab" aria-controls="cancelacion"
                                    aria-selected="false"><i className="fa fa-car"></i>&nbsp;&nbsp;&nbsp;Cancelación de viajes</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade active show" id="asignacion" role="tabpanel" aria-labelledby="asignacion-tab">
                            {
                                this.state.isAsignacion &&
                                <AsignacionConductores
                                    vehiculos={this.state.vehiculos}
                                    vehiculosFiltered={vehiculosFiltered}
                                    conductores={this.state.conductores}
                                    conductoresFiltered={conductoresFiltered}
                                    empresa={this.state.empresa}
                                    empresas={this.state.empresas}
                                    filteredRutas={this.state.filteredRutas}
                                    changeEmpresa={this.changeEmpresa}
                                    isLoading={this.state.isLoading}
                                    actualizar={()=>this.filterRutas}
                                    cambiarFecha={this.getFechaEspecifica}
                                    fecha={this.state.fecha}
                                />
                            }
                        </div>
                        <div className="tab-pane fade" id="cancelacion" role="tabpanel" aria-labelledby="cancelacion-tab">
                            {
                                !this.state.isAsignacion &&
                                <CancelacionViaje
                                    vehiculos={this.state.vehiculos}
                                    conductores={this.state.conductores}
                                    empresa={this.state.empresa}
                                    empresas={this.state.empresas}
                                    filteredRutas={this.state.filteredRutas}
                                    isLoading={this.state.isLoading}
                                    cambiarFecha={this.getFechaEspecifica}
                                    fecha={this.state.fecha}
                                />   
                            }
                        </div>
                    </div>
                </div>
                <footer className="footer-pg mt-auto py-3" style={{width:'100%'}}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4 col-sm-4">
                                    </div>
                                    <div className="col-sm">
                                        <img src={copyright}/>
                                    </div>
                                </div>
                            </div>
                        </footer>
            </div>
            )
    
  }
}

const mapStateToProps = (state) => ({
    programacionDia: state.programacionDia
})

export default connect(mapStateToProps, { setProgramacion })(Rutas);



// WEBPACK FOOTER //
// ./src/Components/Rutas/CambiarViaje.js